import { rem } from '../../../panels/panelLayout';

/**
 * Column spans for the organization profile panels.
 *
 * <p>The supplied design puts most fields two-up (`md:grid-cols-2`) and the
 * Size & ownership row three-up. One grid for every field: mixing a two-up span
 * with a four-up one is what leaves a column not lining up with the one beneath
 * it.
 *
 * <p>Controls fill their column rather than carrying their own max-width. A cap
 * tuned per field type reintroduces the same raggedness one level down --
 * identical columns holding differently-sized controls.
 */
export const FIELD_SPAN = { base: 12, sm: 6 } as const;

/**
 * Employees / Year established / State / Postcode.
 *
 * <p>A quarter row, so the design's `Projected revenue | Employees | Year
 * established` row is one half plus two quarters and lands exactly on 12. An
 * earlier pass used a third here, which pushed Year established onto its own
 * row and left Ownership type starting at a different x from every other
 * right-hand field.
 */
export const QUARTER_SPAN = { base: 6, sm: 3 } as const;

/**
 * The panel's padding, as the design's px measurement.
 *
 * <p>The panel header's rule reaches the card edges while its text stays
 * aligned with the fields below, so the padding and anything that cancels it
 * have to come from this one number. Writing them independently is how they
 * drift.
 */
export const PANEL_PADDING = 20;

/** Apply to the panel header and body. */
export const PANEL_PADDING_REM = rem(PANEL_PADDING);
